import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService, QbService, ToastService } from '@app/services';

@Component({
  selector: 'qb-auth-message',
  template: '',
  styleUrls: [],
})
export class AuthMessageComponent implements OnInit {
  constructor(
    private toast: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    private login: LoginService,
    private qb: QbService
  ) {}

  // Currently only used for Single Sign Out message, but can be used for more.
  ngOnInit(): void {
    this.qb.loading = true;

    const queryParams = this.route.snapshot.queryParams;
    const msg = queryParams['message'];
    const error = queryParams['error'];
    const success = queryParams['success'];
    const redirectUrl = queryParams['redirect'] ?? '/';
    this.router.navigate([redirectUrl]).then(() => {
      if (msg) {
        if (error || success == 'false') {
          this.toast.error(msg, '', 0);
        } else {
          this.toast.info(msg, '', 0);
        }
      }

      if (queryParams['logged_out'] == 'true') {
        this.login.logOutOfSSODomains();
      }
      this.qb.loading = false;
    });
  }
}
